import { isMeProd } from "project/appConfiguration";

const _functionProjectKeys = {
  dev: '5ihcojgwqq-uc',
  prod: 'vhgiud3vyq-uc'
}

/**
 * gets the manifest from the settings of the event/client/home
 * @param {*} clientKey 
 * @param {*} eventKey 
 * @returns a manifest
 */
const getManifestFromFirebaseSettings = async (clientKey, eventKey) => {
  try {
    const isProd = isMeProd()
    const fpk = isProd ? _functionProjectKeys.prod : _functionProjectKeys.dev
    // this will get the manifest from the settings of the event/client/home
    const url = `https://getmanifest-${fpk}.a.run.app?clientKey=${clientKey}&eventKey=${eventKey}`;
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Failed to load manifest: ${res.status}`);
    const data = await res.json();
    return data
  } catch (err) {
    console.log('error', err)
    return {}
  } finally {
    // // nothing
  }
}

const logNotificationPayload = async (error, payload) => {
  try {
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify({
        error: error?.message || error,
        payload
      }),
      headers: { 'Content-Type': 'application/json' }
    };

    const isProd = isMeProd()
    const fpk = isProd ? _functionProjectKeys.prod : _functionProjectKeys.dev
    const url = `https://logNotificationPayload-${fpk}.a.run.app}`;
    const res = await fetch(url, requestOptions);
    // Optional: check response status or log result
    if (!res.ok) {
      console.error('Failed to log notification error:', await res.text());
    } else {
      console.log('Error logged successfully');
    }
    return data
  } catch (err) {
    console.log('error', error)
    return {}
  } finally {
    // // nothing
  }
}

export const firebaseHelpers = {
  getManifestFromFirebaseSettings,
  logNotificationPayload
}